<mat-form-field>
  <mat-label>Filter</mat-label>
  <input matInput type="text" placeholder="Search..." [(ngModel)]="search" autocomplete="off">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
